import { NEWS_PAGE_SIZE } from '@features/news/constants'
import { useResponsive } from '@shared/nuxt/useResponsive'

/**
 * Управляет пагинацией новостей с учётом текущего breakpoint.
 *
 * @returns реактивные параметры и обработчик переключения страницы
 */
export const useNewsPagination = () => {
  const { isDesktop } = useResponsive()

  const countNews = ref(0)
  const currentPage = ref(1)
  const countElementsOnPage = computed(() =>
    isDesktop.value ? NEWS_PAGE_SIZE.desktop : NEWS_PAGE_SIZE.mobile,
  )

  const countPages = computed(() =>
    Math.ceil(countNews.value / countElementsOnPage.value),
  )

  const scrollToTop = () => {
    if (!import.meta.client) return

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const onChangeCurrentPage = (value: number) => {
    currentPage.value = value
    scrollToTop()
  }

  return {
    countNews,
    currentPage,
    countElementsOnPage,
    countPages,
    onChangeCurrentPage,
  }
}
